import { forwardRef, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ALERTS, EMERGENCY_CALLS } from '@rsos/constants/incidentTypes';
import { toggleQueueCollapse } from '@rsos/reduxDataStore/src/features/queue/queueSlice';
import CallTakerModalsContainer from '../../CallTakerMode/Modals/CallTakerModalsContainer';
import { Container } from './ActionBar.styles';
import { Spacer } from './ActionBar.styles';
import AirAmbulanceActionBarItem from './AirAmbulance/AirAmbulanceActionBarItem';
import AlertsActionBarItem from './Alerts/AlertsActionBarItem';
import ArchiveViewActionBarItem from './ArchiveView/ArchiveViewActionBarItem';
import CallQueueFilters from './CallQueueFilters/CallQueueFilters';
import CallTakerModeActionBarItem from './CallTakerMode/CallTakerModeActionBarItem';
import useCallTakerModeHelpers from './CallTakerMode/useCallTakerModeHelpers';
import CollapseQueueActionBarItem from './CollapseQueue/CollapseQueueActionBarItem';
import EmergencyCallsActionBarItem from './EmergencyCalls/EmergencyCallsActionBarItem';
import OutboundSMSActionBarItem from './OutboundSMS/OutboundSMSActionBarItem';
import RadiosActionBarItem from './Radios/RadiosActionBarItem';
import RoadsideAssistanceActionBarItem from './RoadsideAssistance/RoadsideAssistanceActionBarItem';
import SearchActionBarItem from './Search/SearchActionBarItem';

const ActionBar = memo(
  /**
   * @param {Object} props
   * @param {boolean} props.hasAlertsAccess - Whether the user has access to alerts
   * @param {Function} props.onQueueTabClick - Function to handle queue tab click
   */
  forwardRef((props, ref) => {
    const { hasAlertsAccess, onQueueTabClick } = props;
    const dispatch = useDispatch();
    const isCollapsed = useSelector(state => state.queue?.isQueueCollapsed);

    const {
      callTakerModeSettings,
      handleCallTakerModeClick,
      hasCallTakerModeAccess,
      isCallTakerModeModalOpen,
      setIsCallTakerModeModalOpen,
    } = useCallTakerModeHelpers();

    const handleClickSearch = () => {
      dispatch(toggleQueueCollapse());
      const searchInput = document.querySelector(
        'input[data-name="universal-search"]',
      );
      if (searchInput) {
        searchInput.focus();
      }
    };

    const handleClickAlerts = () => {
      dispatch(toggleQueueCollapse());
      onQueueTabClick(ALERTS);
    };

    const handleClick911 = () => {
      dispatch(toggleQueueCollapse());
      onQueueTabClick(EMERGENCY_CALLS);
    };

    return (
      <>
        <Container data-name="action-bar" isCollapsed={isCollapsed} ref={ref}>
          <SearchActionBarItem onClick={handleClickSearch} />

          <CollapseQueueActionBarItem />

          {isCollapsed && <Spacer />}

          <EmergencyCallsActionBarItem onClick={handleClick911} />

          <AlertsActionBarItem
            onClick={handleClickAlerts}
            hasAlertsAccess={hasAlertsAccess}
          />

          {isCollapsed && <Spacer />}

          <RoadsideAssistanceActionBarItem />

          <AirAmbulanceActionBarItem />

          <ArchiveViewActionBarItem />

          <RadiosActionBarItem />

          <CallTakerModeActionBarItem
            onClick={handleCallTakerModeClick}
            hasCallTakerModeAccess={hasCallTakerModeAccess}
            callTakerModeSettings={callTakerModeSettings}
          />

          <OutboundSMSActionBarItem />
          <CallQueueFilters />
        </Container>

        <CallTakerModalsContainer
          isCTMClicked={isCallTakerModeModalOpen}
          setIsCTMClicked={setIsCallTakerModeModalOpen}
        />
      </>
    );
  }),
);

export default ActionBar;
